<template>
  <div id="login">Oturumunuz kapatılıyor...</div>
</template>

<script>
/* eslint-disable */

import axios from 'axios'
export default {
  name: 'LogoutPage',
  data () {
    return {
      sessionid: ''
    }
  },
  methods: {
    logoutOnLoad () {
      this.$store.dispatch('logout').then(() => this.$router.push('/login'))
    }
  },
  mounted() {
    this.logoutOnLoad();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/LogoutPage.vue